"use client";
import type { ReactNode } from "react";
import ScrollReveal from "./ScrollReveal";

type SectionHeadingProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  className?: string;
};

/**
 * Consistent section header used across the homepage: small uppercase
 * "badge" eyebrow, gradient-capable heading, optional supporting copy.
 */
export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  className = "",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";

  return (
    <ScrollReveal className={`max-w-2xl ${alignment} ${className}`}>
      {eyebrow && (
        <span
          className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] mb-4"
          style={{
            color: "#00d4ff",
            background: "rgba(0,212,255,0.08)",
            border: "1px solid rgba(0,212,255,0.25)",
          }}
        >
          {eyebrow}
        </span>
      )}
      <h2
        className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 tracking-tight"
        style={{ color: "#f1f5f9" }}
      >
        {title}
      </h2>
      {description && (
        <p className="text-sm sm:text-base" style={{ color: "var(--muted-text, #94a3b8)" }}>
          {description}
        </p>
      )}
    </ScrollReveal>
  );
}
